const sameValue = (a, b) =>
  (a === null || a === undefined ? "" : String(a).trim()) ===
  (b === null || b === undefined ? "" : String(b).trim());

// A refetch hands a form new server values. Fields the user hasn't touched
// (still equal to the previous server value) follow the new ones; fields being
// edited keep the user's value.
export const mergeUntouched = (current, previous, next) => {
  const merged = { ...next };
  Object.keys(current || {}).forEach((key) => {
    if (!sameValue(current[key], previous?.[key])) merged[key] = current[key];
  });
  return merged;
};
